export default "__VITE_ASSET__4f81abf6__"